var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"fecha"},[_c('p',[_vm._v(" "+_vm._s(_vm.hora_ida)+" "+_vm._s(_vm.hora_ida.substring(0, 2) > 12 ? "HRS" : "HRS")+" - "+_vm._s(_vm.hora_vuelta)+" "+_vm._s(_vm.hora_ida.substring(0,2) > 12 ? "HRS" : "HRS")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }